import * as webAds from './webAds';

// Detectar si estamos en app nativa (Capacitor) o web
export const isApp = typeof window !== 'undefined' && window.Capacitor !== undefined && window.Capacitor.isNativePlatform();
export const platform = isApp ? 'app' : 'web';

// En web siempre usamos webAds.
// En app, appAds se carga dinámicamente solo cuando se necesita (AdMob no existe en web).
export async function showRewardedAd() {
  if (isApp) {
    const appAds = await import('./appAds');
    return appAds.showRewardedAd();
  }
  return webAds.showRewardedAd();
}

// Intersticial sin recompensa (cada 3 juegos)
export async function showInterstitialAd() {
  if (isApp) {
    const appAds = await import('./appAds');
    return appAds.showInterstitialAd();
  }
  return webAds.showInterstitialAd();
}

export async function checkAvailability() {
  return webAds.checkAvailability();
}
